import Shimmer from "@/shared/components/ui/Loaders/Shimmer";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";
import { Info } from "lucide-react";

const MetricItem = ({ title, value, bgcolor, txtcolor, reason, isLoading }) => {
  const metricContent = (
    <div className="flex items-start justify-start flex-col">
      <p className="text-gray-500 dark:text-gray-400 mb-1 text-start">{title}</p>
      {!isLoading ? (
        <div
          className={`metric-bg inline-flex items-center gap-1 ${bgcolor} dark:bg-gray-800/80 px-2 py-1 rounded`}
        >
          <span
            className={`metric-text ${txtcolor} rounded-sm font-semibold text-[10.5px] flex items-center gap-2`}
          >
            {value}
            {reason && (
              <CustomCommonTooltip
                content={reason}
                className="text-xs text-gray-500 dark:text-gray-300"
              >
                <span className="inline-flex cursor-pointer">
                  <Info
                    size={12}
                    className={
                      txtcolor === "text-green-600" || txtcolor.includes("emerald")
                        ? "text-emerald-500"
                        : "text-gray-500 dark:text-gray-400"
                    }
                  />
                </span>
              </CustomCommonTooltip>
            )}
          </span>
        </div>
      ) : (
        <div className="w-full">
          <Shimmer className="w-full h-6 rounded-sm" />
        </div>
      )}
    </div>
  );

  return metricContent;
};

export default MetricItem;
